(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ActivityTypeInfoSearch', ActivityTypeInfoSearch);

    ActivityTypeInfoSearch.$inject = ['$resource'];

    function ActivityTypeInfoSearch($resource) {
        var resourceUrl = 'api/_search/activity-type-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
